import './SingleLayerSettingsStory.css'
import Parser from 'html-react-parser';
import { useEffect, useState } from "react";
import { getLayerStory } from "./singleLayerService";

export function SingleLayerSettingsStory({ id }) {
    const [story, setStory] = useState({
        id: 0,
        layer_id: 0,
        description: "loading..."
    });

    useEffect(() => {
        getLayerStory(id).then((response) => {
            setStory(response.data)
        })
    }, [id]);

    return (
        <div className="layerStoryTellContainer">
            <div className="layerStoryTell">
                {(!story || story.description === "") && <p>No data found</p>}
                {story && Parser(story.description)}
            </div>
        </div>
    )
}